import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  clearFont: {
    color: theme.palette.ePrimary?.base,
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
  },
  topicContains: {
    color: theme.palette.eDark?.base,
    fontSize:"small"
  },
}));
export default function TopicContain({ searchWord, clearHandler }) {
  const classes = useStyle();
  const {t:labels, ready: labelReady}=useTranslation("label-E_ALERTS_AND_NOTIFICATION")

  return (
    <>
      {searchWord && (
        labelReady?
        <span className={classes.topicContains}>
          {labels("E_METER_ALERTS_TOPIC_CONTAIN")} "{searchWord}"
        </span>
        : <Skeleton />
      )}
      {
        labelReady ?
        <span className={classes.clearFont} onClick={clearHandler}>
          &nbsp; {labels("E_METER_ALERTS_CLEAR")}
        </span> :<Skeleton />
      }
    </>
  );
}